/**
 * 撮影予定（Issue #732）: 撮影の流れ（対戦の状態と撮影予定の列。docs/live-match-flow.md）の画面。
 * ナビの「撮影」（/shoot）の最初のタブ。以前はダッシュボードに帯として置いていた。列に足すのはデュエル一覧の試合の行の「撮影予定に追加」。
 */
import { usePageTitle } from '../appInfo';
import LiveAccessPanel from '../components/LiveAccessPanel';
import LiveDevicesPanel from '../components/LiveDevicesPanel';
import LiveMatchPanel from '../components/LiveMatchPanel';
import RecordingUploadsPanel from '../components/RecordingUploadsPanel';
import ShootNav from '../components/ShootNav';

export default function LiveSchedule() {
  usePageTitle('撮影予定');
  return (
    <>
    <ShootNav />
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">撮影予定</h1>
      </div>
      <LiveDevicesPanel />
      <LiveMatchPanel />
      <RecordingUploadsPanel />
      <LiveAccessPanel />
    </div>
    </>
  );
}
